<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-id-badge"></i> Mesa de Atendimento</h3>
      </div>
    </div>
    <MesaAdd v-if="showAdd" ref="MesaAdd" v-on:Back="onBack" />
    <MesaList v-else ref="MesaList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import MesaAdd from './components/add/mesaadd.vue'
import MesaList from './components/list/mesalist.vue'

export default {
  name: 'Mesa',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    MesaAdd,
    MesaList
  },
  mounted () { },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.MesaAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/nxSenhas/mesa/mesa.vue